"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#DA343F",
  fillRule: "evenodd",
  d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#280104",
  d: "M13.5 11c-.21 0-.4-.13-.47-.34-.09-.26.05-.55.32-.63l2.99-1c.26-.09.54.05.63.32.09.26-.05.55-.32.63l-3 1c-.05.02-.11.03-.16.03l.01-.01Zm-3 0c-.05 0-.11 0-.16-.03l-3-1a.491.491 0 0 1-.31-.63c.08-.26.36-.4.63-.31l3 1c.26.09.4.37.32.63-.07.21-.26.34-.47.34h-.01Zm5.5 4.6c-.16 0-.31-.06-.43-.18-.01-.01-1.34-1.32-3.57-1.32-2.23 0-3.56 1.31-3.57 1.32a.6.6 0 1 1-.85-.85c.07-.07 1.68-1.68 4.43-1.68s4.36 1.61 4.43 1.68c.23.24.23.62 0 .85-.12.11-.27.17-.42.17l-.02.01Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#280104",
  d: "M9.25 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Zm5.5 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=WorstPainPossibleIcon24.js.map